import { TABLET_SHEET_MQ } from './layouts';

/**
 * tabletSheet — the shared "is this the tablet tier?" probe for the Live bottom-bar selectors (Overlays /
 * Layout / System info). Below desktop (< 1280) those render their content as a bottom SHEET (the mobile
 * presentation bubbling up through tablet); at >= 1280 they stay desktop popovers. One query, one place, so
 * the three selectors can't drift (#86bb7phhh, David — tablet = sheets, desktop = modals, 1280 = touch->mouse).
 *
 * matchTabletSheet() — current match (SSR/no-matchMedia safe → false).
 * onTabletSheetChange(cb) — subscribe; cb(matches) on change; returns an unsubscribe. No-op teardown when
 *   matchMedia is unavailable (jsdom without a mock).
 */
export const matchTabletSheet = () =>
  (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(TABLET_SHEET_MQ).matches : false);

export const onTabletSheetChange = (cb) => {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const mql = window.matchMedia(TABLET_SHEET_MQ);
  const handler = () => cb(mql.matches);
  if (mql.addEventListener) mql.addEventListener('change', handler);
  else if (mql.addListener) mql.addListener(handler); // Safari < 14 / older engines
  return () => {
    if (mql.removeEventListener) mql.removeEventListener('change', handler);
    else if (mql.removeListener) mql.removeListener(handler);
  };
};
